import React, { useCallback, useState } from "react";
import { ChevronLeft } from "lucide-react";
import { IoArrowBackOutline } from "react-icons/io5";

import {
  SubtleWrapper,
  LocationSelector,
} from "../../admin/common/form-elements";
import location_info_image from "../../../assets-user/post-property/location_info_image.png";
import RightSideInfoCard from "./RightSideInfoCard";
import { showError } from "../../../utils/toastUtils";
import BackHeader from "./BackHeader";

const Tab2LocationDetails = ({ formData, setFormData, onNext, onBack }) => {
  const updateLocation = useCallback(
    (updatedLocation) => {
      setFormData((prev) => ({
        ...prev,
        location: updatedLocation,
      }));
    },
    [setFormData]
  );
  useState(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleContinue = () => {
    if (!formData.location?.coordinates?.length) {
      showError("Please pick a location on the map");
      return;
    }
    onNext();
  };

  return (
    <div className="flex flex-col xl:flex-row relative w-full no-scrollbar px-3 sm:px-4 md:px-6 lg:px-10 ">
      {/* Left Section */}
      <div className="w-full xl:w-[70%] mx-auto">
        {/* Back Button */}
        <BackHeader title="Location Details" onBack={onBack} />

        <div className="max-w-3xl space-y-6 pb-10 mx-auto">
          {/* Map Location Picker */}
          <SubtleWrapper title="Select Property Location on Map">
            <LocationSelector
              value={formData.location}
              onChange={(updatedLocation) => updateLocation(updatedLocation)}
            />
          </SubtleWrapper>

          {/* Continue Button */}
          <div className="flex gap-3 my-8 p-4">
            <button
              className="flex-1 px-6 py-3 border-2 active:scale-[0.98] border-public-highlight text-public-highlight rounded-full font-medium hover:bg-public-highlight/5 transition-all duration-200"
              onClick={handleContinue}
            >
              Continue
            </button>
          </div>
        </div>
      </div>

      {/* Right Section */}
      <div className="xl:w-[30%] mb-10 xl:mb-0 xl:min-h-screen bg-gray-50  sm:px-4  ">
        <div className="xl:sticky top-28">
          <RightSideInfoCard
            image={location_info_image}
            title="Why Location Matters?"
            description="A precise location boosts your listing’s trust and discoverability. Buyers rely heavily on map accuracy to shortlist properties, plan visits, and evaluate surroundings like schools, marketplaces, and connectivity."
          />
        </div>
      </div>
    </div>
  );
};

export default Tab2LocationDetails;
